// export const CLOUDINARY_API_KEY = '123456789';
// export const CLOUDINARY_CLOUD_NAME = 'archer';
// export const CLOUDINARY_UPLOAD_PRESET = 'hrmaneja-candidates';
export const CLOUDINARY_CLOUD_NAME = 'archer';

export const CLOUDINARY_UPLOAD_PRESET = 'poster-bot';